import { createStore } from 'zustand'
import { StatsModalStore } from './types'

export const createStatsModalStore = () => {
  return createStore<StatsModalStore>()((set, get) => ({
    isOpen: false,
    content: null,
    open: (content) => set({ isOpen: true, content }),
    close: () => {
      set({ isOpen: false })

      setTimeout(() => {
        set({ content: null })
      }, 300)
    },
  }))
}
